// Generated by CoffeeScript 1.11.1
(function() {
  var ResolutionInfo;

  module.exports = ResolutionInfo = (function() {
    ResolutionInfo.prototype.id = 1005;

    ResolutionInfo.prototype.name = 'resolutionInfo';

    function ResolutionInfo(resource) {
      this.resource = resource;
      this.file = this.resource.file;
    }

    ResolutionInfo.prototype.parse = function() {
      this.h_res = this.file.readInt() / 65536;
      this.h_res_unit = this.file.readShort();
      this.width_unit = this.file.readShort();
      this.v_res = this.file.readInt() / 65536;
      this.v_res_unit = this.file.readShort();
      this.height_unit = this.file.readShort();
      return this.resource.data = this;
    };

    ResolutionInfo.prototype["export"] = function() {
      var data, i, key, len, ref;
      data = {};
      ref = ['h_res', 'h_res_unit', 'width_unit', 'v_res', 'v_res_unit', 'height_unit'];
      for (i = 0, len = ref.length; i < len; i++) {
        key = ref[i];
        data[key] = this[key];
      }
      return data;
    };

    return ResolutionInfo;

  })();

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/resources/resolution_info.js
// module id = 100
// module chunks = 0